/**
 * Constants for the Renter Screening Criteria modal form.
 * Aligned with ZRM listing criteria types and options.
 */

export const NOT_APPLICABLE = 'Not applicable';

export const PET_COUNT_MIN = 0;
export const PET_COUNT_MAX = 9;

export const PET_TYPE_OPTIONS: Array<{
  label: string;
  key: 'petCatCount' | 'petSmallDogCount' | 'petLargeDogCount';
}> = [
  { label: 'Cats', key: 'petCatCount' },
  { label: 'Small dogs (under 40 lb)', key: 'petSmallDogCount' },
  { label: 'Large dogs (over 40 lb)', key: 'petLargeDogCount' },
];

/** Shown when "Are pets allowed?" is Yes but no pet type has a maximum set (matches ZRM). */
export const PET_TYPE_REQUIRED_MESSAGE = 'Add at least one pet type to continue';

export const INCOME_TO_RENT_OPTIONS = [
  { label: 'Not set', value: NOT_APPLICABLE },
  { label: '1.5x', value: '1.5x' },
  { label: '1.75x', value: '1.75x' },
  { label: '2x', value: '2x' },
  { label: '2.25x', value: '2.25x' },
  { label: '2.5x', value: '2.5x' },
  { label: '2.75x', value: '2.75x' },
  { label: '3x', value: '3x' },
  { label: '3.25x', value: '3.25x' },
  { label: '3.5x', value: '3.5x' },
  { label: '3.75x', value: '3.75x' },
  { label: '4x', value: '4x' },
];

export const CREDIT_SCORE_OPTIONS = [
  { label: 'Not set', value: NOT_APPLICABLE },
  ...Array.from({ length: (735 - 500) / 5 + 1 }, (_, i) => {
    const value = (500 + i * 5).toString();
    return { label: value, value };
  }),
  { label: '740+', value: '740+' },
];

/** Maps income-to-rent ratio string (e.g. '2x') to multiplier for min income calculation */
export const INCOME_TO_RENT_MULTIPLIER: Record<string, number> = {
  '': 1,
  [NOT_APPLICABLE]: 1,
  '1.5x': 1.5,
  '1.75x': 1.75,
  '2x': 2,
  '2.25x': 2.25,
  '2.5x': 2.5,
  '2.75x': 2.75,
  '3x': 3,
  '3.25x': 3.25,
  '3.5x': 3.5,
  '3.75x': 3.75,
  '4x': 4,
};

export const CRITERIA_SECTION_INTRO =
  "We display these criteria on your listing and use them to help review prospective renters, so you can quickly see who's a good fit for your property.";

export const PET_SECTION_INTRO =
  'Fifty-nine percent of renters have at least one pet. Adding your pet policy can help attract the right renters.';

export const EXPERIAN_CREDIT_SCORE_URL =
  'https://www.experian.com/blogs/ask-experian/credit-education/score-basics/what-is-a-good-credit-score/';

export const ASSISTANCE_ANIMALS_URL = 'https://www.hud.gov/program_offices/fair_housing_equal_opp/assistance_animals';
